import styled from 'styled-components';

export {
  Title,
  Paragraph,
  SectionHeading,
  Form,
  SubmitButton,
  StatusMessage,
  LegalNotice,
} from '../styles';

export const FormCard = styled.div`
  background-color: ${({ theme }) => theme.colors.porterBlue50};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.label`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

const fieldStyles = ({ theme }) => `
  width: 100%;
  padding: 10px 12px;
  font-family: inherit;
  font-size: 16px;
  line-height: 1.4;
  color: ${theme.colors.semantic.text.primary};
  background-color: ${theme.colors.semantic.surface.card};
  border: 1px solid ${theme.colors.semantic.border.default};
  border-radius: 8px;

  &::placeholder {
    font-size: 14px;
    color: ${theme.colors.semantic.text.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.porterBlue500};
    outline-offset: 1px;
  }
`;

export const TextInput = styled.input`
  ${fieldStyles}
`;

export const TextArea = styled.textarea`
  ${fieldStyles}
  min-height: 88px;
  resize: vertical;
`;

export const FieldHint = styled.span`
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.semantic.text.secondary};
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.semantic.text.primary};

  li::marker {
    color: ${({ theme }) => theme.colors.porterBlue500};
  }
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
`;
